require( './../css/style.scss' );

import 'slick-carousel';
import 'ez-plus';
import 'lightbox2';
import { HomeSlider } from './modules/home-slider';
import { SmallSlider } from './modules/small-slider';
import { Gallery } from './modules/gallery';
import { Sidebar } from './modules/sidebar';
import { Product } from './modules/product';
import * as Input from './modules/input';
import { Modal } from './modules/modal';
import * as Registration from './modules/registration';
import { RequestForm } from './modules/request';
import { OrderSimple } from './modules/account';
import * as CategoryDescription from './modules/category-description';
import * as Search from './modules/search';
import * as Cart from './modules/cart';
import * as Menu from './modules/menu';
import * as Ordine from './modules/ordine';
import { PopUp } from './modules/pop-up';
import { Category } from './modules/category';

class APP {
	constructor() {
		window.dataLayer = window.dataLayer || [];
		document.addEventListener('DOMContentLoaded', this.onReady.bind(this));
	}

	onReady() {
		if (document.querySelector('.c-box__slider')) {
			new HomeSlider();
		}

		if (document.querySelector('.c-small-slider')) {
			new SmallSlider();
		}

		if (document.querySelector('.c-header')) {
			Menu.init();
		}

		if (document.querySelector('.c-gallery')) {
			new Gallery();
		}

		if (document.querySelector('.sidebar')) {
			new Sidebar();
		}

		if (document.querySelector('.c-slider')) {
			new Product();
		}

		if (document.querySelector('.input')) {
			Input.init();
		}

		if (document.querySelector('.m-login')) {
			new Modal();
		}

		if (document.querySelector('.registration') || document.querySelector('.contact-form')) {
			Registration.init();
		}

		if (document.querySelector('.btn-request')) {
			new RequestForm();
		}

		if (document.querySelector('.btn-more')) {
			new OrderSimple();
		}

		if (document.querySelector('.c-teaser__box')) {
			CategoryDescription.init();
		}

		if (document.querySelector('.c-search')) {
			Search.init();
		}

		if (document.querySelector('.js-add-cart') || document.querySelector('.c-quantity-group') || document.querySelector('.cart-product')) {
			Cart.init();
		}

		if (document.querySelector('.is-cart')) {
			Ordine.init();
		}

		if (document.querySelector('.m-popup')) {
			new PopUp();
		}

		if( document.querySelector('.js-ancestor') || document.querySelector('.js-filtra-per') ){
			new Category( Cart );
		}

	}
}

new APP();



// WEBPACK FOOTER //
// ./src/js/app.js